import styled, { keyframes } from "styled-components";

// Theme colors
export const colors = {
    shimmerGradient: "linear-gradient(90deg, #e2e2e7 0%, #d0d1d7 52.08%, #e2e2e7 100%)",
};

// Keyframe animations
export const shimmerAnimation = keyframes`
    0% {
        background-position: -1000px 0;
    }
    100% {
        background-position: 1000px 0;
    }
`;

// Styled components
export const Container = styled.div`
    height: 100%;
    background: ${({ theme }) => theme.colors[theme.colorMode].background_Secondary};
    padding: ${({ theme }) => theme.spacing.medium};
`;

export const Block = styled.div`
    margin-bottom: 36px;

    &.fixed-bottom {
        margin-bottom: 0;
        z-index: 9;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        border-radius: ${({ theme }) => theme.spacing.medium} ${({ theme }) => theme.spacing.medium} 0 0;
        background: ${({ theme }) => theme.colors[theme.colorMode].background_Primary};
    }
`;

export const BlockHeader = styled.div<{ width?: number }>`
    background: ${colors.shimmerGradient};
    background-size: 1000px 100%;
    animation: ${shimmerAnimation} 2s infinite linear;
    height: ${({ theme }) => theme.spacing.medium};
    margin-bottom: ${({ theme }) => theme.spacing.large};
    width: ${props => props.width || 30}%;
`;

export const BlockContent = styled.div`
    background: ${({ theme }) => theme.colors[theme.colorMode].background_Primary};
    box-shadow: 0px 1px ${({ theme }) => theme.spacing.medium} rgba(0, 0, 0, 0.05);
    border-radius: ${({ theme }) => theme.spacing.medium};
    padding: ${({ theme }) => theme.spacing.medium};
    min-height: 80px;

    &:not(:last-child) {
        margin-bottom: ${({ theme }) => theme.spacing.medium};
    }

    &.footer-bottom {
        padding-bottom: calc(var(--sab, 0px) + ${({ theme }) => theme.spacing.medium});
    }
`;

export const BlockSavingsBanner = styled.div`
    background: ${colors.shimmerGradient};
    background-size: 1000px 100%;
    animation: ${shimmerAnimation} 2s infinite linear;
    height: 44px;
    border-radius: 16px;
`;

export const LineBase = styled.div<{ width?: number; height?: number }>`
    background: ${colors.shimmerGradient};
    background-size: 1000px 100%;
    animation: ${shimmerAnimation} 2s infinite linear;
    width: ${props => props.width || 100}%;
    height: ${props => props.height}px;
`;

export const StyledLine = styled(LineBase)<{ fat?: boolean }>`
    height: ${props => props.height || (props.fat ? 16 : 12)}px;
`;

export const StyledCircle = styled.div<{ size?: number }>`
    background: ${colors.shimmerGradient};
    background-size: 1000px 100%;
    animation: ${shimmerAnimation} 2s infinite linear;
    border-radius: 100%;
    width: ${props => props.size || 20}px;
    height: ${props => props.size || 20}px;
`;

export const Row = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    flex: 1;

    &:last-child {
        margin-bottom: 6px;
    }

    > * {
        margin-bottom: 0;
    }
`;

export const Col = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;
    flex: 1;

    &:only-child {
        margin-bottom: 6px;
    }

    > *:not(:last-child) {
        margin-bottom: 16px;
    }
`;

export const Divider = styled.div`
    height: 2px;
    margin: 12px -16px 24px;

    &.padded {
        margin: 12px auto 24px;
    }
`;
